<div *ngIf="!hasVariations" class="product-pricing">
  <div class="product-pricing__container">
    <h4>{{ hasPromo ? "Normal" : "Preço" }}</h4>
    <span class="normal-price" [class.risky]="hasPromo">
      {{ price | currency : "BRL" : "symbol" : "1.2-2" }}
    </span>
  </div>

  <div *ngIf="hasPromo" class="product-pricing__container">
    <h4>Promocional</h4>
    <span class="promo-price">
      {{ promotionalPrice | currency : "BRL" : "symbol" : "1.2-2" }}
    </span>
  </div>

  <div *ngIf="pixPrice" class="product-pricing__container">
    <h4>Pix</h4>
    <span class="pix-value">
      {{ pixPrice | currency : "BRL" : "symbol" : "1.2-2" }}
    </span>
  </div>
</div>
